import { api } from 'src/utils/api';

const find = id => api.get(`/products/${id}`);

const create = ({ name, interest = 1, fine = 2 }) => api.post('/products', {
    name,
    interest,
    fine,
});

const update = (id, params) => api.put(`/products/${id}`, params);

const list = () => api.get('/products');

export {
    create, update, list, find,
};
